// GETTERS
export const PAYABLES_TO_SHOW = 'payables/PAYABLES_TO_SHOW'
export const PARAMS_TO_SEND = 'payables/PARAMS_TO_SEND'

// MUTATIONS
export const SET_PAYABLES = 'payables/SET_PAYABLES'
export const SET_PAGINATION = 'payables/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'payables/SET_TOTAL_ITEMS'
export const SET_IS_LOADING = 'payables/SET_IS_LOADING'
export const SET_FILTERS = 'payables/SET_FILTERS'
export const SET_PAYABLE_DETAILS = 'payables/SET_PAYABLE_DETAILS'
export const SET_INVOICE_INFO = 'payables/SET_INVOICE_INFO'

// ACTIONS
export const GET_PAYABLES = 'payables/GET_PAYABLES'
export const CHANGE_PAGINATION = 'payables/CHANGE_PAGINATION'
export const CHANGE_FILTERS = 'payables/CHANGE_FILTERS'
export const RESET_PAGINATION = 'payables/RESET_PAGINATION'
export const GET_PAYABLE_DETAILS = 'payables/GET_PAYABLE_DETAILS'
export const OPEN_INVOICE = 'payables/OPEN_INVOICE'
export const APPROVE_PAYABLE_REQUEST = 'payables/APPROVE_PAYABLE_REQUEST'
export const CANCEL_PAYABLE_REQUEST = 'payables/CANCEL_PAYABLE_REQUEST'
